<input
  spellcheck="false"
  autocomplete="off"
  [value]="value"
  (input)="emitValue($event.target)"
/>
